module.exports = __webpack_public_path__ + "static/twowaveblacktop-2d723e473583b6286782fa49a827f114.jpg";